<template>
  <modal
    :show.sync="showEditPassengerModal"
    bodyClasses="pt-0"
    size="lg"
    @close="closeModal"
    no-close-on-backdrop
  >
    <template slot="header" class="pb-0">
      <h6 class="subtitle" id="modal-title-default">
        Edit Passenger
      </h6>
    </template>
    <div class="row forms mt-4">
      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-6 form-group">
        <label for="title" class="title-label">Type</label>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            v-model="passenger.type"
            :aria-describedby="ariaDescribedby"
            id="type"
            name="type"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="SENIOR" class="pc-5" tabindex="3"
              >Senior</b-form-radio
            >
            <b-form-radio value="ADULT" class="pc-5">Adult</b-form-radio>
            <b-form-radio value="CHILD" class="pc-5">Child</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-6 form-group">
        <label for="title" class="title-label">Title</label>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            v-model="passenger.gender"
            :aria-describedby="ariaDescribedby"
            id="radio-gender"
            name="radio-gender"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="male" class="pc-5" tabindex="3"
              >Mr.</b-form-radio
            >
            <b-form-radio value="female" class="pc-5">Mrs.</b-form-radio>
            <b-form-radio value="other" class="pc-5">Mx.</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <base-input
          v-model.trim="$v.passenger.first_name.$model"
          inputClasses="text-capitalize"
          label="First Name"
          placeholder="First Name"
          id="ncfirst_name_passengerModal"
          name="ncfirst_name_passengerModal"
          tab-index="15"
          format="capitalize"
          minlength="2"
          maxlength="45"
          markrequired
          :error="
            $v.passenger.first_name.$error
              ? `Must be between ${$v.passenger.first_name.$params.minLength.min} and ${$v.passenger.first_name.$params.maxLength.max} characters.`
              : ''
          "
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <base-input
          v-model.trim="$v.passenger.last_name.$model"
          label="Last Name"
          inputClasses="text-capitalize"
          placeholder="Last Name"
          id="nclast_name_passengerModal"
          name="nclast_name_passengerModal"
          tab-index="16"
          format="capitalize"
          minlength="2"
          maxlength="45"
          markrequired
          :error="
            $v.passenger.last_name.$error
              ? `Must be between ${$v.passenger.last_name.$params.minLength.min} and ${$v.passenger.last_name.$params.maxLength.max} characters.`
              : ''
          "
        />
      </div>

      <div
        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 inputphone form-group"
        v-bind:class="{ 'is-invalid': $v.passenger.phone.$error }"
        @paste.capture="handlePhonePaste"
      >
        <label class="title-label">Contact Number</label>
        <vue-tel-input
          v-model="contactNumber"
          key="NumberPhonepassenger"
          inputId="NumberPhonepassengerModal"
          name="NumberPhonepassengerModal"
          required
          mode="international"
          inputClasses="input no-label no-err"
          :dynamicPlaceholder="true"
          :disabledFetchingCountry="true"
          :validCharactersOnly="true"
          :wrapperClasses="[
            $v.passenger.phone.$error ? 'is-invalid' : '',
            'mb-0'
          ]"
          @input="validateContactNumber"
        ></vue-tel-input>
        <small class="invalid-feedback mt-1" v-if="$v.passenger.phone.$error">
          {{ getPhoneNumberValidationErrorMessage($v.passenger.phone) }}
        </small>
      </div>

      <div class="col-xl-6 col-lg-5 col-md-6 col-sm-12 col-12">
        <base-input
          id="passenger_email_modal"
          name="passenger_email_modal"
          v-model.trim="$v.passenger.email.$model"
          label="Email Address"
          placeholder="Email Address"
          format="lowercase"
          :error="getEmailValidationErrorMessage($v.passenger.email)"
          autocomplete="off"
          markrequired
        />
      </div>

      <div
        class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12"
        v-if="
          ['arrival', 'departure', 'station', 'port'].includes(transferType)
        "
      >
        <base-input
          :label="getLabelTransferType(transferType)"
          v-model="flightNumber"
          id="flightNumberModal"
          name="flightNumberModal"
          format="uppercase"
        />
      </div>
      <div class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12">
        <label for="driver_notifications" class="title-label ml-0">
          Send Notification
          <el-popover placement="top" trigger="hover" width="300" class="curp">
            <span>
              Enable this option to send a notification to the passenger when
              the reservation is saved.
            </span>
            <div class="badge badge-primary" slot="reference">
              ?
            </div>
          </el-popover>
        </label>
        <base-switch
          v-model="sendNotification"
          class="mt-2"
          @input="setSendNotification"
        ></base-switch>
      </div>
    </div>

    <div class="modal-footer col-12">
      <base-button
        type="outline-secondary"
        class="min-button"
        @click="closeModal"
      >
        Close
      </base-button>

      <base-button
        type="primary"
        class="min-button mb-0 ml-auto"
        @click="savePassenger()"
        :disabled="loadingRequest"
      >
        <i class="flaticon-floppy-disk"></i> Save
      </base-button>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters } from "vuex";
import { VueTelInput } from "vue-tel-input";
import { PassengersAPI } from "../../core/api";
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
  requiredIf
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚŽž'-\s]*$/);

import { v4 as uuidv4 } from "uuid";
export default {
  name: "EditPassenger",
  components: {
    VueTelInput
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    partner: {
      type: Object,
      default: () => {
        return {
          id: null,
          type: ""
        };
      },
      description: "(Owner identifier)"
    },
    tempPassenger: {
      type: Object,
      default: () => null
    },
    passengers: {
      type: Array,
      default: () => [],
      description: "(passengers by customers)"
    },
    transferType: {
      type: String,
      required: true,
      description:
        "(arrival, departure, station, port, hourly, journey) Transfer Type"
    }
  },
  data() {
    return {
      passenger: {
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        gender: "male",
        type: "ADULT"
      },
      contactNumber: "",
      flightNumber: "",
      showEditPassengerModal: false,
      passengerId: null,
      sendNotification: false,
      loadingRequest: false,
      lastContactNumber: "",
      lastPassengerEmail: "",
      primary: false,
      reference: ""
    };
  },
  async created() {},
  watch: {
    show: {
      handler: function(current, old) {
        this.showEditPassengerModal = current;
      },
      deep: true
    },
    tempPassenger: {
      handler: function(current, old) {
        if (current) {
          this.passenger.first_name = current.firstName;
          this.passenger.last_name = current.lastName;
          this.passenger.full_name = current.fullName;
          this.passenger.email = current.email;
          this.$v.passenger.email.$model = this.passenger.email;
          this.passenger.phone = current.phone;
          this.$v.passenger.phone.$model = this.passenger.phone;
          this.passenger.gender = current.gender;
          this.passenger.type = current.type;
          this.flightNumber = current.flightNumber;
          this.contactNumber = this.passenger.phone;
          this.lastContactNumber = this.passenger.phone;
          this.lastPassengerEmail = this.passenger.email;
          this.passengerId = current._id;
          this.sendNotification = current.notify;
          this.primary = current.primary;
          this.reference = current.reference;
        }
      },
      deep: true
    }
  },
  methods: {
    async savePassenger() {
      if (!this.$v.passenger.$invalid) {
        var passenger = lodash.cloneDeep(this.passenger);
        passenger.full_name = `${passenger.first_name} ${passenger.last_name}`;
        if (this.passengerId) {
          this.loadingRequest = true;
          await this.updatePassengerById(this.passengerId, passenger);
          this.loadingRequest = false;
        } else {
          this.loadingRequest = true;
          await this.addPassenger(passenger);
          this.loadingRequest = false;
        }
      } else {
        this.$v.passenger.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updatePassengerById(passengerId, passenger) {
      try {
        let { data } = await PassengersAPI.updateAnyAttributeById(
          passengerId,
          passenger,
          this.sesion.token
        );
        if (data.status) {
          let tempPassenger = data.data.passenger;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Passenger has been Saved",
            icon: "flaticon-check-3"
          });
          this.$emit(
            "changePassenger",
            this.populatePassenger(
              tempPassenger,
              this.flightNumber,
              this.sendNotification
            )
          );
          this.closeModal();
          return;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the Passenger, please try again",
            icon: "flaticon-remove"
          });
          return;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Passenger, please try again",
          icon: "flaticon-remove"
        });
        return;
      }
    },
    handlePhonePaste(e) {
      e.preventDefault();
      const raw = (e.clipboardData || window.clipboardData).getData("text");
      this.contactNumber = raw
        .replace(
          /[\u0000-\u001F\u007F-\u009F\u00A0\u00AD\u180E\u200B-\u200F\u202A-\u202E\u2028\u2029\u202F\u205F\u2060\u2066-\u2069\uFEFF]/g,
          ""
        )
        .trim();
      this.$nextTick(() => {
        const input = document.getElementById("NumberPhonepassengerModal");
        if (input) input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    },
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.valid) {
        this.passenger.phone = result.number.e164;
        this.$v.passenger.phone.$model = this.passenger.phone;
      } else {
        this.passenger.phone = value;
        this.$v.passenger.phone.$model = this.passenger.phone;
      }
    },
    async verifyPassengerEmail(email, customerId) {
      try {
        if (email) {
          let { data } = await PassengersAPI.checkPassengers(
            {
              passengerId: this.passengerId,
              email: email.toLowerCase(),
              "relationship.owner": customerId
            },
            this.sesion.token
          );
          if (data.status) {
            return !data.data.exists;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async verifyPassengerPhone(phone, customerId) {
      try {
        if (email) {
          let { data } = await PassengersAPI.checkPassengers(
            {
              passengerId: this.passengerId,
              phone: phone,
              "relationship.owner": customerId
            },
            this.sesion.token
          );
          if (data.status) {
            return !data.data.exists;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    selectPassengerType(value) {
      this.passenger.type = value ? "CHILD" : "ADULT";
    },
    populatePassenger(passenger, flightNumber, sendNotification) {
      return {
        _id: passenger._id,
        reference: this.reference ? this.reference : uuidv4(),
        firstName: passenger.first_name,
        lastName: passenger.last_name,
        fullName: passenger.full_name,
        email: passenger.email,
        phone: passenger.phone,
        gender: passenger.gender,
        type: passenger.type,
        primary: this.primary,
        notify: sendNotification,
        flightNumber: flightNumber
      };
    },
    clearData() {
      this.passenger = lodash.cloneDeep({
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        gender: "male",
        type: "ADULT"
      });
      this.contactNumber = "";
      this.flightNumber = "";
      this.lastContactNumber = "";
      this.lastPassengerEmail = "";
      this.primary = false;
      this.reference = "";
      this.sendNotification = false;
      this.$v.passenger.$reset();
    },
    closeModal() {
      this.showEditPassengerModal = false;
      this.clearData();
      this.$emit("close", false);
    },
    async addPassenger(passenger) {
      if (passenger) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Passenger has been Saved",
          icon: "flaticon-check-3"
        });
        this.$emit(
          "changePassenger",
          this.populatePassenger(
            passenger,
            this.flightNumber,
            this.sendNotification
          )
        );
        this.closeModal();
        return;
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Passenger, please try again",
          icon: "flaticon-remove"
        });
        return;
      }
    },
    setSendNotification(value) {
      if (this.$v.passenger.email.$model === "") {
        this.$v.passenger.email.$reset();
      }
    },
    getLabelTransferType(transferType) {
      if (["arrival", "departure"].includes(transferType)) {
        return "Flight N°";
      } else if (transferType === "station") {
        return "Rail Line";
      } else if (transferType === "port") {
        return "Cruise Ship";
      } else {
        return "";
      }
    },
    getEmailValidationErrorMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    getPhoneNumberValidationErrorMessage(phone) {
      if (phone.$error) {
        if (!phone.minLength || !phone.maxLength) {
          return `Entenr a valid Contact Number.`;
        }

        if (!phone.customValidator) {
          return "Contact Number is already in use by another PAX.";
        }
      }
      return "";
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    passenger: {
      first_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      email: {
        required: requiredIf(function(value) {
          return this.sendNotification;
        }),
        customValidator: async function(value) {
          if (value) {
            if (this.lastPassengerEmail !== value) {
              return this.validateEmail(value)
                ? await this.verifyPassengerEmail(value, this.partner.id)
                : false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      },
      phone: {
        minLength: minLength(9),
        maxLength: maxLength(17),
        customValidator: async function(value) {
          if (value) {
            if (this.lastContactNumber !== value) {
              return value.length >= 9 && value.length <= 17
                ? await this.verifyPassengerPhone(value, this.partner.id)
                : false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      }
    }
  }
};
</script>
